import { useEffect, useState } from 'react';
import { APPROVAL_WORKFLOW_TYPES } from '../../../_constants';
import ApprovalsRequest from '../../../../../../../Classes/ResponseModels/ApplicationManagement/ApprovalRequest';
import Spinner from '../../../../../../../components/UI/Spinner/Spinner';
import {
	GetApprovers,
	UpdateApprovers,
	CheckApprovalWorkFlowType,
	CreateApprovalFlow,
} from '../../../../../_api';
import AppExtensionCreate from './AppExtensionCreate/AppExtensionCreate';
import AppExtensionsDisplay from './AppExtensionsDisplay/AppExtensionsDisplay';

//this component rendered if the selected application is setup for multi level approvals
const MultiLevelApprovals = ({
	app,
	currentUser,
	readOnly,
	requirementNumber,
}) => {
	const [workflowAlreadyExists, setWorkFlowAlreadyExists] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [appExtensions, setAppExtensions] = useState([]);

	//on load, check if supporting records for multi level approval work flow exists:
	useEffect(() => {
		CheckApprovalWorkFlowType(
			app.appMaster.id,
			APPROVAL_WORKFLOW_TYPES.MultiLevel
		)
			.then(response => {
				setWorkFlowAlreadyExists(response);
				GetApprovers(
					app.appMaster.id,
					APPROVAL_WORKFLOW_TYPES.MultiLevel
				).then(response => {
					setAppExtensions(response?.applicationExtensions);
				});
			})
			.then(x => {
				setIsLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = () => {
		let request = new ApprovalsRequest(
			app,
			currentUser,
			APPROVAL_WORKFLOW_TYPES.MultiLevel,
			null,
			appExtensions,
			requirementNumber
		);
		request.RequirementNumber = requirementNumber;
		setIsLoading(true);
		//if workflow doesnt already exist, require window.confirm selection, create approval flow AND THEN update approvers, if it does already exist, do not display window.confirm and only update approvers.
		if (
			!workflowAlreadyExists &&
			window.confirm(
				'This will create the required entries in TS_Event_Matrix table for multi level approval work flow. Removal of these records will require manual intervention after insertion. Would you like to continue?'
			)
		) {
			CreateApprovalFlow(request).then(success => {
				if (success) {
					UpdateApprovers(request)
						.then(resp => {
							setAppExtensions(resp.applicationExtensions);
						})
						.then(x => {
							setIsLoading(false);
						});
				}
			});
		} else {
			UpdateApprovers(request)
				.then(resp => setAppExtensions(resp.applicationExtensions))
				.then(x => {
					setIsLoading(false);
				});
		}
	};

	return (
		<div>
			<h2>Multi Level Approval</h2>
			{isLoading ? (
				<Spinner />
			) : (
				<>
					<AppExtensionsDisplay
						app={app}
						currentUser={currentUser}
						appExtensions={appExtensions}
						setAppExtensions={setAppExtensions}
						readOnly={readOnly}
						requirementNumber={requirementNumber}
					/>
					<AppExtensionCreate
						app={app}
						currentUser={currentUser}
						appExtensions={appExtensions}
						handleSave={handleSave}
						workflowAlreadyExists={workflowAlreadyExists}
						setWorkflowAlreadyExists={setWorkFlowAlreadyExists}
						setAppExtensions={setAppExtensions}
						disabled={readOnly}
						requirementNumber={requirementNumber}
					/>
				</>
			)}
		</div>
	);
};

export default MultiLevelApprovals;
